<template>
  <div class="order-pages">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">短信统计&nbsp;/&nbsp;</span>
      </div>
      <div>详情</div>
    </div>
    <div class="member-content-box br10 p16">
      <div class="flex-row query-title">
        <div v-for="(item,index) in tabList" :key="index" :class="[tabActive == index ? 'tabActiveClass':'']" @click="onTabClick(index)" class="query-item">{{item}}</div>
      </div>
      <div class="align-item wraps " v-if="tabActive == 0">
        <div class="select-title">选择月份：</div>
        <el-date-picker v-model="query.reportMonth" type="month" :clearable="false" value-format="yyyy-MM" placeholder="选择月" class="w200"></el-date-picker>
        <el-button type="primary" class="ml10" @click="doList">搜索</el-button>
      </div>
      <div class="align-item wraps" v-if="tabActive == 1">
        <div class="select-title">选择时间：</div>
        <v-notDate :beginTime="query.beginTime" :endTime="query.endTime" @time="changeDate"></v-notDate>
        <el-button type="primary" class="ml10" @click="doListCount">搜索</el-button>
      </div>
      
      
    </div>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="flex-row query_tab" v-if="tabActive == 1">
          <div v-for="(item,index) in queryList" :key="index" :class="[queryActive == item.value ? 'query_active':'']" @click="onQueryClick(item)" class="query_select_item">{{item.name}}</div>
        </div>
        <div class="p16">
          <el-table :data="list" :max-height="height - 410" header-cell-class-name="table_header_bgcolor" :show-summary='tabActive == 0 ? true:false' :summary-method="getSummaries">
            <el-table-column
              :prop="index"
              :align="item.align"
              :label="item.label"
              :width="item.width"
              :min-width="item.minWidth"
              :show-overflow-tooltip="false"
              v-for="(item,index) in columns"
              :key="index"
            >
              <template slot-scope="scope">
                <div v-if="index == 'reportDate'">{{formatDay(scope.row.reportDate)}}</div>
                <div v-else>{{Boolean(item.formatDay)?formatDate(scope.row[index]):scope.row[index]}}</div>
              </template>
            </el-table-column>

            <el-table-column prop="leftNum" label="短信余量" align="center" width="100" v-if="tabActive == 1 && (query.source == 'buy' || query.source == 'sysGive')">
            </el-table-column>
            
            <el-table-column prop="amt" label="操作" align="center" width="140" v-if="tabActive == 1 && (query.source == 'buy' || query.source == 'smsSend')">
              <template slot-scope="scope">
                <el-link type="primary" @click="openDetail(scope.row)">详情</el-link>
              </template>
            </el-table-column>
          </el-table>
          <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doListCount" v-if="tabActive == 1"></paging>
        </div>
      </div>
    </div>
    <edit-set ref="editForm"></edit-set>
    <detail-set ref="detailSetForm"></detail-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/colums";
import editSet from "./payRecordsDetails.vue";
import detailSet from "../../datas/smsTemplate/detail.vue";
export default {
  mixins: [minxin],
  components: {},
  data() {
    return {
      columns: config.detail,
      totalAmount: 0,
      form: {
        memberId: "",
      },
      url: this.$url.smsStatisticsDay.smsStatisticsList,
      list: [],
      query: {
        reportMonth: '',
      },
      tabList: ['每日明细', '短信明细'],
      tabActive: 0,
      queryList: [{name: '短信订购', value: 'buy'},{name: '短信消耗', value: 'smsSend'},{name: '短信赠送', value: 'sysGive'},{name: '短信返还', value: 'sysReturn'},],
      queryActive: 'buy',
      totals: {},
      height: this.$store.getters.MainHeight,
      dialogHide: false
    };
  },
  components: {editSet,detailSet},
  created() {
    if (this.$route.query.reportMonth) {
      this.query.reportMonth = this.$route.query.reportMonth
    } else {
      this.query.reportMonth = this.formatMonth(new Date())
    }
    this.getData();
    this.getSummary()
  },
  mounted () {},
  methods: {
    back() {
      this.$router.push("/manage/smsSendTotal");
    },
    onTabClick (index) {
      this.tabActive = index;
      this.list = []
      if (index == 0) {
        this.columns = config.detail
        this.getData();
        this.getSummary()
      } else {
        this.query.start = 1;
        this.query.beginTime = this.formatDay(new Date());
        this.query.endTime = this.query.beginTime;
        this.columns = config.smsDetail
        this.query.source = this.queryActive
        this.getListCount()
      }

    },
    doList () {
      this.getData();
      this.getSummary()
    },
    doListCount (val) {
			if (val.start || val.size) {
				this.query = Object.assign(this.query, val)
			} else {
				this.query = Object.assign(this.query, val)
      }
			this.getListCount()
		},
    async getSummary () {
      let res = await this.$api.post(this.$url.smsStatisticsDay.smsStatisticsSummary, this.query)
      if (res) this.totals = res;
    },
    getSummaries(param) {
			// 设置汇总字段
			const { columns, data } = param
			const sums = []
			columns.forEach((column, index) => {
				sums[0] = '小计'
				if (Object.getOwnPropertyNames(this.totals).length != 0) {
					sums[1] = this.totals.rechargeTotal
					sums[2] = this.totals.giveTotal
					sums[3] = this.totals.sendTotal
					sums[4] = this.totals.successTotal
					sums[5] = this.totals.failTotal
				}
			})
			return sums
		},
    async getListCount () {
      let res = await this.$api.post(this.$url.smsStatisticsDay.listSmsDetail, this.query)
      let ret = await this.$api.post(this.$url.smsStatisticsDay.countSmsDetail, this.query)
      if (res) this.list = res;
      this.totalCount = ret;
    },
    onQueryClick (item) {
      this.query.source = item.value
      this.query.start = 1
      this.queryActive = item.value
      this.getListCount()
    },
    changeDate(value) {
      this.query.start = 1;
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
    },
    openDetail (item) {
      // this.dialogHide = true
      if (this.query.source == 'buy') {
        this.$refs["editForm"].$emit("set", item.orderId);
      } else if (this.query.source == 'smsSend') {
        this.$refs["detailSetForm"].$emit("set", item.messageRecordId);
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.member-content-box {
  margin: 0 16px 16px;
  background: #fff;
  .query-item {
    cursor: pointer;
    &:last-child {
      margin-left: 30px;
    }
  }
}
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  background: #fff;
}
.tabActiveClass {
  color: #1E5FDD;
}
.query_tab {
  padding: 16px 16px 0;
}
.query-title {
  font-size: 18px;
  padding-bottom: 16px;
}
.query_select_item {
  padding: 5px;
  margin-right: 10px;
  background-color: #ececec;
  border-radius: 2px;
  cursor: pointer;
}
.query_active {
  color: #226BF6;
  background-color: #81d3f8;
}
</style>
